import { buttonsTypes } from '@/utils'
import React from 'react'

const CustomButton = ({ title, action = () => {}, disabled = false, type = 'button', colorType = 'light' }) => {

  return (
    <button type={type} onClick={action} disabled={disabled} className={`flex h-11 items-center justify-center border px-4 text-sm 2xl:text-base font-semibold select-none focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-blue-800 rounded ${buttonsTypes[colorType]}`}>
      {title}
    </button>
  )
}

export default CustomButton